const ENDPOINT = new Map();

ENDPOINT.set('enroll', '/plugin/course/enroll');
ENDPOINT.set('redirect', '/plugin/course/redirect');
ENDPOINT.set('activate', '/plugin/course/activate');

export default ENDPOINT
